/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import { Header } from '../../components/header/Header';
import { Footer } from '../../components/footer/Footer';
import { Product } from './App';

global.React = React;
global.ReactDOM = ReactDOM;

// Simple hack to introduce a new property on the global
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(global as any).Components = { Header, Footer, Product };
